/**
 * Non Post Order Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getLogsAction,
  getOrderWithIdAction,
  updateOrderStatusActions,
} from '../orders/actions';
import Client from 'client-sdk/src/client';
import { UpdateOrderDeliveryCost } from 'client-sdk/src/orders/orders';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectLogs,
} from '../orders/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  IconButton,
  TextField,
  FormHelperText,
  MenuItem,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiCalendar,
  mdiStateMachine,
  mdiAccountOutline,
  mdiArrowRight,
  mdiPencilOutline,
  mdiClose,
  mdiPhoneOutline,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiWarehouse,
  mdiKeyOutline,
  mdiCityVariantOutline,
  mdiSendCircleOutline,
  mdiWeight,
  mdiRuler,
  mdiCounter,
  mdiKey,
  mdiPaperRollOutline,
  mdiPackageVariant,
  mdiCurrencyUsd,
  mdiRefresh,
  mdiMapMarkerCheckOutline,
  mdiPackageVariantClosed,
  mdiDotsHorizontalCircleOutline,
  mdiClipboardCheckOutline,
  mdiTruckFastOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiEmail,
} from '@mdi/js';

// Components
import Can from '../../components/Can';
import List from './list';
import OrderChildList from './orderChildList';

// Helper
import {
  translate,
  formaterPhoneNumber,
  packegeCounter,
  convertPersianDigit2English,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import handleNotfication from '../../utils/handleNotfication';

// Type
import { Status } from '../orders/interfaces';
import { SelectorProps, Props } from '../orderDetails/interfaces';
import { Link } from 'react-router-dom';
import { mdiText } from '@mdi/js/commonjs/mdi';
import orderRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import AlopeykRequest from '../orders/components/alopeykRequest';
import Modal from '../../components/Modal';
// import {isEmpty} from 'lodash';
import { Card } from '@material-ui/core';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@material-ui/lab';
import { CardHeader } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import ListOrderItems from './itemList';
import orderItemsRepository from 'client-sdk/src/Repository/order-items.repository';
import { DatePicker, MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import InfoCard from '../nonPostOrderDetails/infocard';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      marginBottom: '8px',
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    rtlIcon: {
      marginRight: theme.spacing(1),
      transform: 'scale(-1, 1)',
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 600,
      marginRight: '10px',
      flex: 0.5,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    retryIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.gray.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    retryTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    submitbtn: {
      backgroundColor: '#2F4858',
      padding: '8px',
      color: '#fff',
      borderRadius: '5px',
      fontWeight: 600,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#3F5969',
      },
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible !important',
      padding: '14px',
      paddingBottom: '0',
      '@media (max-width: 768px)': {
        overflow: 'auto',
      }
    },
    contentBox: {
      marginTop: '-1px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'right',
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },

    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paperHistory: {
      alignItems: 'center',
    },
  })
);

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};
const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};
export function NonPostOrderDetails(props: Props) {
  const authContext = useContext(AuthContext);
  const token = localStorage.getItem('token') || '';
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [openRetryItem, setOpenRetryItem] = React.useState(false);
  const [error, setError] = useState('');
  const [request3PLError, setRequest3PLError] = useState('');
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [openDelaySMS, setOpenDelaySMS] = useState(
    false as boolean
  );
  const [delayTime, setDelayTime] = useState<string | undefined>(undefined);
  const [order3PLs, setOrder3PLs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [request3PLLoading, setRequest3PLLoading] = useState(false);
  const [item, setItem] = useState({} as any);
  const [description, setDescription] = useState('');
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [orderDeliveryCost, setOrderDeliveryCost] = useState<null | number>(
    null
  );
  const [orderItems, setOrderItems] = useState([]);



  const classes = useStyles();
  useEffect(() => {
    const { id } = props.match.params;

    getOrder();
    getOrder3PLs();
    props.getLogsDispatch(id);
    getOrderItems({ 'orderId.equals': id, size: 1000 });

  }, []);

  useEffect(() => {
    if (props.order?.deliveryCost) {
      setOrderDeliveryCost(props.order?.deliveryCost);
    }
  }, [props.order]);

  const getOrder = () => {
    const { id } = props.match.params;
    props.orderWithIdActionDispatch(id);
  };

  const getOrder3PLs = () => {
    const { id } = props.match.params;
    const filters = { orderId: { equals: id }, unpaged: true };
    get3PLs({ ...filters });
  };

  const get3PLs = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.getOrder3PLs({
        payload,
      });
      setOrder3PLs(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const getOrderItems = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const response = await orderItemsRepository.getAllOrderItems({ payload });
      setOrderItems(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const changeStatusOrder = () => {
    const { id } = props.match.params;
    props.updateOrderStatusDispatch({
      id: props.order.id,
      body: previewState.replace(/"/g, ''),
      pagination: {},
      callback: () => props.orderWithIdActionDispatch(id),
    });
    handleClose();
  };

  const cancelItem = (item: any) => {
    setItem(item);
    setOpenDeleteItem(true);
  };
  const retrylItem = (item: any) => {
    setItem(item);
    setOpenRetryItem(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };
  const handleCloseRetryDialog = () => {
    setOpenRetryItem(false);
  };

  const cancelOrder3PL = async () => {
    const payload = {
      id: item.id,
      body: { description: description },
      callback: () => {
        getOrder();
        getOrder3PLs();
        setOpenDeleteItem(false);
      },
    };
    try {
      setLoading(true);
      const { callback } = await orderRepository.cancel3PLItems({
        payload,
      });
      handleNotfication('آیتم مورد نظر با موفقیت لغو شد ', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const retryOrder3PL = async () => {
    const payload = {
      id: item.id,
      callback: () => {
        getOrder();
        getOrder3PLs();
        setOpenRetryItem(false);
      },
    };
    try {
      setLoading(true);
      const { response, callback } = await orderRepository.sendRequestOrder3PL({
        payload,
      });
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  const handleCloseDelaySMS = () => {
    setDelayTime(null)
    setOpenDelaySMS(false)
  };

  const sendSMS = async () => {
    const { id } = props.match.params;
    const payload = { id, body: `"` + delayTime.slice(-5) + `"` }
    try {
      await ordersRepository.sendDelayDeliveryOrderTimeSms({ payload })
      handleCloseDelaySMS()
      handleNotfication("پیامک با موفقیت ارسال شد", "success")
    } catch (err) {
      handleError(err)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات سفارش
     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{props.order.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
        <Can
          perform="orderDetail:print"
          role={authContext.user.role}
          yes={() => (
            <Link
              to={`/orders/receipts/${props.order.id}`}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                color="secondary"
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                  authContext.user.role === 'WAREHOUSE_ADMIN'
                  ? 'چاپ رسید'
                  : 'چاپ حواله'}
              </Button>
            </Link>
          )}
        />
      </Grid>

      <Grid container
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px', marginTop: '32px' }}>
        <InfoCard order={props.order} />
        <Grid item lg={9} md={9} sm={12} xs={12} spacing={2} >
          {props.order.childOrders?.length > 0 && (
            <Card>
              <CardHeader title={
                <Typography>
                  لیست سفارش های زیر مجموعه سفارش {props.order.id}
                </Typography>
              } />
              <Grid>
                <OrderChildList data={props.order.childOrders} />
              </Grid>
            </Card>
          )}
          <Card style={{ marginTop: '8px' }}>
            <Grid
              // style={{ margin: 0 }}
              container
              // spacing={1}
              justify="space-between"
              alignItems="center"
            >
              <Grid item>
                <h3 style={{ marginTop: 0 }}>{'اطلاعات پیک'}</h3>
              </Grid>
              <Grid container justifyContent='flex-end' spacing={2}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Icon path={mdiEmail} size={1} />}
                    onClick={() => setOpenDelaySMS(true)}
                  >
                    {'پیامک تاخیر'}
                  </Button>
                </Grid>
                {props.order.orderTPLType === 'ALOPEYK' && (
                  <Grid item>
                    <Button
                      onClick={() => setOpenAlopeykRequest(true)}
                      variant="contained"
                    >
                      {'جزئیات بیشتر'}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid
              style={{ margin: 0 }}
              container
              spacing={1}
              justify="space-between"
              alignItems="center"
            >
              <Grid item xs={6}>
                <img
                  style={{ width: '60px', objectFit: 'contain' }}
                  src={
                    `/${props.order.orderTPLType}.png`
                  }
                  alt={props.order.tpl}
                />
              </Grid>
              <Grid item xs={6}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                    {'تاریخ ثبت در 3PL:  '}
                  </span>
                  <span>
                    {props.order.submitToTPLDate &&
                      `${jMoment(props.order.submitToTPLDate, 'YYYY/MM/DD HH:mm:ss')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD HH:mm:ss')}`}
                  </span>
                </div>
              </Grid>
            </Grid>
            <Grid>
              {order3PLs && (
                <List
                  data={order3PLs}
                  cancelItem={cancelItem}
                  retrylItem={retrylItem}
                />
              )}
            </Grid>
          </Card>
          <Card style={{ paddingTop: '0', marginTop: '8px' }}>
            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              props.order?.items && (
                <>
                  <ListOrderItems
                    data={orderItems}
                  />
                </>
              )
            )}
          </Card>
          <Card style={{ marginTop: '16px' }}>
            <Grid item xs={12}>
              <Timeline align="left" style={{ minWidth: '500px' }}>
                {props.logs
                  ?.slice()
                  .reverse()
                  .map((log, index: number) => (
                    <TimelineItem
                      className={classes.missingOppositeContent}
                      key={index}
                    >
                      <TimelineSeparator>
                        <TimelineDot
                          style={{
                            backgroundColor: colorStatus[log.newStatus],
                            border: index === 0 ? 'solid 4px #DF9234' : '',
                          }}
                        >
                          <Icon path={iconStatus[log.newStatus]} size={1} />
                        </TimelineDot>
                        {index !== props.logs?.length - 1 ? (
                          <TimelineConnector />
                        ) : (
                          ''
                        )}
                      </TimelineSeparator>
                      <TimelineContent className={classes.paperHistory}>
                        <div style={{ padding: '10px' }}>
                          <div className={classes.contentBox}>
                            <div style={{ flex: 1.5, textAlign: 'right' }}>
                              <span className={classes.contentlabel}>
                                وضعیت سفارش:
                              </span>
                              <span data-cy="status">
                                {translate(log.newStatus, 'order')}
                              </span>
                            </div>
                            <div
                              style={{
                                flex: 2,
                                textAlign: 'right',
                                justifyContent: 'center',
                              }}
                            >
                              <span className={classes.contentlabel}>
                                کاربر:
                              </span>
                              <Can
                                role={authContext.user.role}
                                perform="user-name:dontShowInLogs"
                                no={() => (
                                  <>
                                    <span>{log.modifierName}</span>
                                    <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                                  </>
                                )}
                              />
                              <span data-cy="role">
                                {translate(log.modifierRole, 'user')}
                              </span>
                            </div>
                            <Typography component="div" style={{ flex: 1 }}>
                              {log.time &&
                                jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                  .locale('fa')
                                  .format('jYYYY/jMM/jDD - HH:mm')}
                            </Typography>
                          </div>
                        </div>
                      </TimelineContent>
                    </TimelineItem>
                  ))}
              </Timeline>
            </Grid>
          </Card>

        </Grid>
      </Grid>

      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت سفارش
        "${translate(props.order.status, 'order')}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'order')}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={changeStatusOrder}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="lg"
        fullScreen
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={
          <div>
            <h3
              style={{ display: 'flex', marginBottom: 0, alignItems: 'center' }}
            >
              {`ارسال درخواست سفارش 
                   ${props.match.params.id} 
                    به `}
              <strong>
                {translate(props.order.orderTPLType, "TPL")}
              </strong>
              <img
                style={{ width: '60px', objectFit: 'contain', margin: '0 20px' }}
                src={'/ALOPEYK.png'}
                alt={'alopeyk'}
              />
            </h3>
          </div>
        }
        content={
          <AlopeykRequest
            orderId={props.match.params.id}
            id={order3PLs[order3PLs.length - 1]?.id}
          />
        }
      />
      <Dialog
        fullWidth
        open={openDelaySMS}
        onClose={handleCloseDelaySMS}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              // className={classes.closeButton}
              onClick={handleCloseDelaySMS}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <TimePicker
                fullWidth
                label={"زمان"}
                variant="inline"
                ampm={false}
                format="HH:mm"
                className={classes.textInput}
                autoOk
                clearable
                labelFunc={date =>
                  date?.isValid() ? date.format('HH:mm') : ''
                }
                value={delayTime}
                name="delayTime"
                id="delayTime"
                onChange={value => {
                  return setDelayTime(
                    value &&
                    convertPersianDigit2English(
                      value.format('jYYYY/jMM/jDD HH:mm')
                    )
                  );
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={handleCloseDelaySMS}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={sendSMS}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog open={openDeleteItem} onClose={handleCloseDialog}>
        <DialogContent style={{ width: '600px' }}>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialog}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <p>
            آیا از لغو آیتم 3PL با شناسه
            <strong> {item.id} </strong> مطمئن هستید
          </p>
          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item} style={{ width: '100%' }}>
              <span className={classes.label}>
                <Icon path={mdiText} size={1} className={classes.icon} />
              </span>

              <span style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                  className={classes.textInput}
                />
              </span>
            </div>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={cancelOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                disabled={loading || !description}
              >
                {`بله`}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                fullWidth
                autoFocus
              >
                {`خیر`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog open={openRetryItem} onClose={handleCloseRetryDialog}>
        <DialogContent style={{ width: '600px' }}>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseRetryDialog ? (
              <IconButton aria-label="retry" onClick={handleCloseRetryDialog}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.retryIcon}>
            <Icon path={mdiRefresh} size={4} color={theme.palette.gray.main} />
          </div>
          <div className={classes.retryTitle}>از ارسال سفارش مطمئن هستید</div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={retryOrder3PL}
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
              >
                {`بله`}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseRetryDialog}
                variant="contained"
                fullWidth
                autoFocus
              >
                {`خیر`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  order: makeSelectOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
      callback?: () => void;
    }) => dispatch(updateOrderStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(NonPostOrderDetails);
